import React from "react";
import "../../styles/survey-form/survey-form.scss";
// import { Link } from "react-router-dom";
// import Logo from "../../assets/logo.png";
import Logo from "../../assets/Logo and describer white.png"
import { useMediaQuery } from 'react-responsive';

const LocationShare = ({ heading, icon, showQrCodeIcon, onClose,userId,sharingLocation ,className, children}) => {
  const isDesktop = useMediaQuery({ minWidth: 767 })

  return (
    <div className="login-container"> 
    
      <div className="form-animation" >
        {!isDesktop ? <div className="location-image-logo">
                <img src={Logo} alt="Roam smart tracker" />
              </div> : null}
      
        <div className={`form-animation-image ${className}`}>
          {showQrCodeIcon && <span className="form-animation-bg"></span>}
          {icon && <img src={icon} alt="Icon" />}
        </div>
        {sharingLocation 
          ? (
            <p>
              <span>Hold tight! We’re pinpointing the exact location using </span>
              <span style={{ color: '#93B8A1' }}>What3Words</span>
              <span>. Thank you for your patience.</span>
            </p>
          ) 
          : (
            <p>
              <span>Success! Location Shared. Thank you for your help!</span>
            </p>
          )
        }
        {children}
      </div>
    </div>
  );
};

export default LocationShare 
